export default {
  actionIcon: 'StarIcon',
  highlightColor: 'warning',
  data: [

    // APPS
    {index: 2, label: 'Device',                       url: '/cbs/devices',                          labelIcon: 'CheckSquareIcon',    highlightAction: false},
    {index: 3, label: 'Request',                       url: '/cbs/request',                          labelIcon: 'MessageSquareIcon',  highlightAction: false},
  ]
}
